import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../../assets/png/JioCloud-Logo.png";
//css
import classes from "./UserRegistrationNavbar.module.css";
import { Alert, Snackbar, Stack } from "@mui/material";
import { AvatarV2, Text } from "@jds/core";
import JdsModal from "../../UI/JdsModal";
import { useDispatch, useSelector } from "react-redux";
import { setSelfieModalClose } from "../../../store/state-slices/userRegistration";
import Selfie from "../../UI/Selfie/Selfie";
import { addParamsURL } from "../../../util/helper";
import { useEffect, useState } from "react";
import SelfieLiveliness from "../../UI/Selfie/SelfieLiveliness";

const UserRegistrationNavbar = () => {

  const path = window.location.pathname; // e.g., "/products/item-123"
  const segments = path.split('/').filter(Boolean); // removes empty strings
  const lastSegment = segments[segments.length - 1];

  console.log(lastSegment); // Output: "item-123"


  const { selfieModalClose } = useSelector((state) => state.userRegistration);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profilePictureThumbnail = localStorage.profilePictureThumbnail !== 'null' ? localStorage.profilePictureThumbnail : null;
  const isJitoUser = (localStorage.eventJWT !== '' && localStorage.eventJWT !== 'null') && localStorage.userRole === 'GUEST'

  const [toastOpen, setToastOpen] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    msg: "Notification",
    type: "success",
  });



  return (
    <>
      <header style={{ height: '50px', padding: '5px 0', backgroundColor: 'var(--color-primary-50)' }}>
        <div className={classes["header__container"]}>
          {/* <NavLink className={classes["header__logo-box"]}>
            
          </NavLink> */}
          <Stack direction="row" gap={1} alignItems="center">
            <img src={logo} alt="jio photos logo" style={{ width: "40px" }} />
            {/* <Text text="JioAICloud" appearance="body-m-bold" color="white" />  */}
          </Stack>
          {lastSegment === 'photos' &&
            <AvatarV2
              size="small"
              avatarKind={
                profilePictureThumbnail
                  ? "image"
                  : "icon"
              }
              image={
                profilePictureThumbnail
                  ? addParamsURL(profilePictureThumbnail, {
                    size: "s",
                  })
                  : ""
              }
              onClick={() => {
                dispatch(setSelfieModalClose(false));
                // navigate("/user-registered/profile-selfie");
              }}
            />}
        </div>
      </header>

      <JdsModal
        kind={"custom"}
        header="Upload Selfie"
        headerProps={{
          divider: "false",
          appearance: 'body-m-bold'
        }}
        size="m"
        close={selfieModalClose}
        onClose={() => {
          dispatch(setSelfieModalClose(true));
        }}
      >
        {!selfieModalClose && <SelfieLiveliness setToastOpen={setToastOpen} setToastInfo={setToastInfo} skip={true} />}
      </JdsModal>

      <Snackbar
        open={toastOpen}
        autoHideDuration={6000}
        onClose={() => {
          setToastOpen(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => {
            setToastOpen(false);
          }}
          severity={toastInfo.type}
          sx={{ width: "100%" }}
        >
          {toastInfo.msg}
        </Alert>
      </Snackbar>
    </>
  );
};
export default UserRegistrationNavbar;
